// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Dashboard-__messages-box__container--3tDWr","table":"src-components-Dashboard-__messages-box__table--bYS_c","headsUp":"src-components-Dashboard-__messages-box__headsUp--1cbKL","row":"src-components-Dashboard-__messages-box__row--3dx58","cell":"src-components-Dashboard-__messages-box__cell--3sKF7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/messages-box.css
// module id = 1964
// module chunks = 0